export default "__VITE_ASSET__B1ak2ZUs__"